export const ASRM = 
{
    Metadata:{Name:'ASRM',maxColumn:1,numRows:5},
    Sections:
    [
        {
            Headers:[
                "Choose one statement in each group that best describes the way you have been feeling for the <span class='importantText'>past week.</span>",
                "I do not feel happier or more cheerful than usual.",
                "I occasionally feel happier or more cheerful than usual.",
                "I often feel happier or more cheerful than usual.",
                "I feel happier or more cheerful than usual most of the time.",
                "I feel happier or more cheerful than usual all of the time."
            ],
            Questions:[
                {
                    Prompt:"Question 1",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
            ]
        },
        {
            Headers:[
                "",
                "I do not feel more self-confident than usual.",
                "I occasionally feel more self-confident than usual.",
                "I often feel more self-confident than usual.",
                "I feel more self-confident than usual.",
                "I feel extremely self-confident all of the time."
            ],
            Questions:[
                {
                    Prompt:"Question 2",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
            ]
        },
        {
            Headers:[
                "",
                "I do not need less sleep than usual.",
                "I occasionally need less sleep than usual.",
                "I often need less sleep than usual.",
                "I frequently need less sleep than usual.",
                "I can go all day and night without any sleep and still not feel tired."
            ],
            Questions:[
                {
                    Prompt:"Question 3",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
            ]
        },
        {
            Headers:[
                "",
                "I do not talk more than usual",
                "I occasionally talk more than usual.",
                "I often talk more than usual.",
                "I frequently talk more than usual.",
                "I talk constantly and cannot be interrupted"
            ],
            Questions:[
                {
                    Prompt:"Question 4",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
            ]
        },
        {
            Headers:[
                "",
                "I have not been more active (either socially, sexually, at work, home or school) than usual.",
                "I have occasionally been more active than usual.",
                "I have often been more active than usual",
                "I have frequently been more active than usual.",
                "I am constantly active or on the go all the time."
            ],
            Questions:[
                {
                    Prompt:"Question 5",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
            ]
        }
    ]
}